import React, {
    useState,
    useEffect,
    Fragment,
} from "react";
import { AddDialog } from "../../Components/AddDialog.jsx";
import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import { getInputs, getRules, getScenarioInput } from "../Pdf/Generate.jsx";
import { AccountTypePrettyNames, inputTexts, RuleTexts, scenInputTexts } from "../Pdf/pgChart3.jsx";
import { faListUl } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { iconSize, myOwnFPColor } from "../../App/GridRenderers.jsx";
import { Arrayify } from "../../Functions/utils.jsx";
import { InputSwitch } from "../../Components/Inputs/Input_Check.jsx";

export const ScenarioInputsViewPort = ({ clientJson }) => {
    const [show, setShow] = useState(false)
    return (
        <>
            <ScenarioInputsIcon
                onClick={() => { setShow(true) }}
            />
            <ScenarioInputView
                clientJson={clientJson}
                open={show}
                onClose={() => setShow(false)}
            />
        </>
    )
}


export const ScenarioInputsIcon = ({ onClick }) => {
    return (
        <>
            <Box sx={{ pt: 1 }}>
                <Tooltip title="Show the scenario inputs"
                    enterDelay={1000}>

                    <FontAwesomeIcon
                        icon={faListUl}
                        onClick={onClick}
                        size={iconSize}
                        color={myOwnFPColor}
                    />
                </Tooltip>
            </Box>
        </>
    );
};




export const getScenarioInputs = async (clientJson, uuid) => {
    //console.log(uuid)

    let input = ""

    let inputs = [1]
    let scenInput = await getScenarioInput(clientJson, uuid, inputs)
    let si = scenInput[0]
    let sit = scenInputTexts(si)

    input += sit.Scenario
    input += sit.Dates

    let highlightLines = []

    highlightLines.push(input.split(/\n/).length)
    input += clientJson.name + "\n"
    input += sit.Client

    let inputResponse = await getInputs(clientJson, uuid, inputs)
    let i = inputResponse[0]
    let at = inputTexts(i.ClientData, i.Clients)
    input += "\n\nAccounts\n"

    Object.entries(at).forEach(([account, value]) => {
        if (value.length > 0) {
            input += account + "\n"
            if (value[0].Text !== "") {
                input += value[0].Text
            }
        }
    })


    let rules = [1]
    let ruleResponse = await getRules(clientJson, uuid, rules)
    let r = ruleResponse[0]
    let c = r.Clients[0]
    let rt = RuleTexts(r.ClientData[c], c)
    input += "Desired Savings\n"
    input += rt.Desired
    input += "\nSurplus Savings\n"
    input += rt.Surplus
    input += "\nAdditional Income\n"
    input += rt.Income

    if (sit.Spouse !== "") {
        highlightLines.push(input.split(/\n/).length)

        input += clientJson.spouseName + "\n"
        input += sit.Spouse
        input += "\n\nAccounts\n"
        Object.entries(at).forEach(([account, value]) => {
            if (value.length > 1) {
                input += account + "\n"
                if (value[1].Text !== "") {
                    input += value[1].Text
                }
            }
        })
        if (r.Clients.length > 1) {
            let c = r.Clients[1]
            let s = ""
            let rt = RuleTexts(r.ClientData[c], c)
            input += "Desired Savings\n"
            input += rt.Desired
            input += "\nSurplus Savings\n"
            input += rt.Surplus
            input += "\nAdditional Income\n"
            input += rt.Income
        }
    }
    // only if we want the tax
    // input += sit.TaxText

    //console.log(highlightLines)

    return [input, highlightLines]
}




export const ScenarioInputView = ({ clientJson, open, onClose }) => {
    const [client, setClient] = useState("")
    const [spouse, setSpouse] = useState("")
    const [cRules, setCRules] = useState({})
    const [sRules, setSRules] = useState({})
    const [cInputs, setCInputs] = useState({})
    const [scenInputs, setScenInputs] = useState({})
    const [showTaxInfo, setShowTaxInfo] = useState(false)


    const getData = async () => {

        let rules = [1]
        let ruleResponse = await getRules(clientJson, clientJson.Scenario.uuid, rules)
        let r = ruleResponse[0]
        console.log(r)
        let c = r.Clients[0]
        setClient(c)
        let s = ""
        if (r.Clients.length > 1) {
            s = r.Clients[1]
        }
        setSpouse(s)
        setCRules(RuleTexts(r.ClientData[c], c))
        console.log(s)
        if (s !== "") {

            setSRules(RuleTexts(r.ClientData[s], s))
        }

        let inputs = [1]
        let inputResponse = await getInputs(clientJson, clientJson.Scenario.uuid, inputs)
        let i = inputResponse[0]

        console.log(i)
        let it = inputTexts(i.ClientData, i.Clients)
        setCInputs(it)
        console.log(it)
        // console.log(inputResponse)

        let scenInput = await getScenarioInput(clientJson, clientJson.Scenario.uuid, inputs)
        let si = scenInput[0]

        console.log(si)
        let sit = scenInputTexts(si)
        setScenInputs(sit)
        console.log(sit)
        // console.log(inputResponse)
    }
    const myClose = () => {
        setClient("")
        setShowTaxInfo(false)
        onClose()
    }


    useEffect(() => {
        if (open) {
            setShowTaxInfo(false)
            getData();
        }
    }, [open])

    const showScenarioInputBasic = (si) => {
        // console.log(si)
        return (
            <>
                <Stack>
                    <ul>
                        <Grid container spacing={10} >
                            <Grid size={6} xs={1}>
                                {Arrayify(si.ScenarioA).map((item, i) => (
                                    <li key={"ssib_s:" + i}>{item}</li>
                                ))}
                            </Grid>
                            <Grid size={6} xs={1}>
                                {Arrayify(si.DatesA).map((item, i) => (
                                    <li key={"ssib_d:" + i}>{item}</li>
                                ))}
                            </Grid>
                        </Grid>
                    </ul>

                </Stack >
                {/* <>
                    {(si.PostRunModified) && (
                        <Typography>
                            {"NOTE:  Input has been modified after this scenario was last executed"}
                        </Typography>
                    )

                    }
                </> */}
            </>
        )
    }

    const emptyJson = {}
    const showScenarioInputs = (si) => {
        // console.log(si)
        return (
            <Stack >
                {(si !== emptyJson) && (
                    <ul>

                        <Grid container spacing={10} >
                            <Grid size={6} xs={1}>
                                {Arrayify(si.ClientA).map((item, i) => (
                                    <li key={"ssi_c:" + i}>{item}</li>
                                ))}
                            </Grid>
                            <Grid size={6} xs={1}>
                                {Arrayify(si.SpouseA).map((item, i) => (
                                    <li key={"ssi_s:" + i}>{item}</li>
                                ))}
                            </Grid>
                        </Grid>

                    </ul>
                )}

            </Stack>
        )
    }
    const showTaxInformation = (si) => {
        // console.log(si)
        return (
            <Stack >
                {(si !== emptyJson) && (
                    <ul>

                        <Grid container spacing={10} >
                            <Grid size={12} xs={1}>
                                {Arrayify(si.TaxTextA).map((item, i) => (
                                    <React.Fragment key={"RF" + i}>
                                        {(!item.includes('\t') && (
                                            <Typography variant="h6">
                                                {item}
                                            </Typography>

                                        ))}
                                        {(item.includes('\t') && (
                                            <ul>
                                                <li>
                                                    {item.replace(/\t/g, '')}
                                                </li>
                                            </ul>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </Grid>

                        </Grid>

                    </ul>
                )}

            </Stack>
        )
    }

    const showList = (name, listc, lists, listct, listst) => {
        console.log(listc)
        return (
            <Stack>
                <Typography variant="h6">
                    {name}
                </Typography>
                <ul>
                    <Grid container spacing={10} >
                        <Grid size={6} xs={1}>

                            {Arrayify(listc).map((item, i) => (
                                <React.Fragment key={"sl1:" + i}>
                                    {item.Year !== "" &&
                                        <Typography variant="h7">
                                            {item.Year}
                                        </Typography>

                                    }
                                    <ul>
                                        <li>{item.Text}</li>
                                    </ul>
                                </React.Fragment>
                            ))}
                        </Grid>
                        <Grid size={6} xs={1}>
                            {listct === listst &&
                                <Typography>
                                    Same
                                </Typography>
                            }
                            {listct !== listst &&
                                Arrayify(lists).map((item, i) => (
                                    <React.Fragment key={"sl2:" + i}>
                                        {item.Year !== "" &&
                                            <Typography variant="h7">
                                                {item.Year}
                                            </Typography>

                                        }
                                        <ul>
                                            <li>{item.Text}</li>
                                        </ul>
                                    </React.Fragment>
                                ))
                            }
                        </Grid>
                    </Grid>
                </ul>
            </Stack >
        )
    }





    const AccountSet = [
        "Employment",
        "Expenses",
        "NonRegistered",
        "InvestLoan",
        "Registered",
        "Retirement",
        "DBPension",
        "Annuity",
        "Liability",
        "Property",
        "Inheritance",
        "Government",

    ]

    const showAccounts = (it) => {
        console.log(it)
        return (
            <Stack>
                {AccountSet.map((item, i) => (
                    (Arrayify(it[item]).length > 0 &&
                        <ul key={"SA::" + i}>
                            <Typography variant="h6">
                                {AccountTypePrettyNames(item)}
                            </Typography>
                            <ul>
                                <Grid container spacing={10} >
                                    {Arrayify(it[item]).map((itemc, iv) => (
                                        <Grid key={"Sa:" + iv} size={6} xs={1}>

                                            {Arrayify(itemc.Array).map((iteml, il) => (
                                                <React.Fragment key={"RF" + il}>
                                                    {iteml.Name !== "" && (
                                                        <Typography>
                                                            {iteml.Name}
                                                            {" " + iteml.Once}
                                                        </Typography>
                                                    )}
                                                    <ul>
                                                        <li>{iteml.Text}</li>
                                                    </ul>
                                                    {iteml.TableText &&
                                                        <>
                                                            <Typography>
                                                                {iteml.Name + " Table"}
                                                            </Typography>

                                                            {Arrayify(iteml.TableText).map((itemltt, i) => (
                                                                <ul key={"SA_UL:" + i}>
                                                                    <li>{itemltt}</li>
                                                                </ul>

                                                            ))

                                                            }
                                                        </>
                                                    }
                                                </React.Fragment>

                                            ))}
                                        </Grid>
                                    ))}
                                </Grid>
                            </ul>
                        </ul >
                    )
                ))
                }
            </Stack>
        )
    }


    return (
        <AddDialog
            clientJson={null}
            c_callback={null}
            onClose={myClose}
            open={open}
            clients={[]}
            client={""}
            label={"Scenario: " + clientJson.Scenario.label}
            onClientChange={() => { }}
            noButtons={true}
            accountType="ScenarioInput"
            PrintFileName={"MyOwnFP: " + clientJson.name + (clientJson.spouseName ? "&" + clientJson.spouseName : "") + " Scenario: " + clientJson.Scenario.label + "_InputSummary"}
        >
            {open && client !== "" &&
                <Stack sx={{ mx: 20, mb: 10 }} spacing={2}>
                    <InputSwitch
                        label="Tax Information"
                        name="TaxInfo"
                        onChange={(_, v) => { setShowTaxInfo(v) }}
                    />
                    <Typography variant="h5">
                        Basic
                    </Typography>
                    {showScenarioInputBasic(scenInputs)}
                    <Grid container spacing={10} >
                        <Grid size={6} xs={1}>
                            <Typography variant="h5">
                                <strong>{client}</strong>
                            </Typography>
                        </Grid>
                        <Grid sx={{ xs: 1 }}>
                            <Typography size={6} variant="h5">
                                <strong>{spouse}</strong>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Typography variant="h5">
                        Clients
                    </Typography>
                    {showScenarioInputs(scenInputs)}
                    <Typography variant="h5">
                        Accounts
                    </Typography>
                    {showAccounts(cInputs)}
                    <Stack spacing={2}>

                    </Stack>
                    <Typography variant="h5">
                        Rules
                    </Typography>
                    <Stack spacing={2}>
                        <ul>
                            {showList("Desired", cRules.DesiredA, sRules.DesiredA, cRules.Desired, sRules.Desired)}
                            {showList("Surplus", cRules.SurplusA, sRules.SurplusA, cRules.Surplus, sRules.Surplus)}
                            {showList("Income", cRules.IncomeA, sRules.IncomeA, cRules.Income, sRules.Income)}
                        </ul>
                    </Stack>
                    {(showTaxInfo &&
                        <>
                            <Typography variant="h5">
                                Tax Information
                            </Typography>
                            {showTaxInformation(scenInputs)}
                        </>
                    )}
                </Stack >
            }
        </AddDialog >

    )

}